import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { usePriceComponents } from "@/components/Sections/Price/hooks/usePriceComponents";
import { ComponentWrapper } from "@/components/Sections/Price/RentView/ComponentWrapper";
import { PriceUnit } from "@/components/Sections/Price/RentView/PriceUnit";
import { Box } from "@gemini/core";
export const PriceComponents = () => {
    var _a;
    const components = ((_a = usePriceComponents()) !== null && _a !== void 0 ? _a : []).filter((component) => component.type !== "PRIMARY");
    return (_jsx(_Fragment, { children: components.map(({ key, type, units }, index) => (_jsx(ComponentWrapper, { type: type, marginTop: index > 0 ? "spacing.16" : "spacing.none", isLast: index === components.length - 1, children: units.map((unit, unitIndex) => (_jsx(Box, { children: _jsx(PriceUnit, { unit: unit, type: type, isLast: unitIndex === units.length - 1 }) }, unit.key))) }, key))) }));
};
